import React, { useEffect, useState } from "react";
import axios from "axios";
import { Card, Grid, Typography } from "@mui/material";
import useStyles from "./style";
import { pricingPersonaNewStatic } from "constant/product";
import { Button, Flex, Text } from "@chakra-ui/react";
import { formatPrice } from "utils/format";
// import {pricingPersonaStatic} from '../../constant/product'

const PricingPersona = (props) => {
  const classes = useStyles();
  const [pricingPlans, setPricingPlans] = useState([]);
  const [expand, setExpand] = useState(-1);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const tmpPricing = pricingPersonaNewStatic;
    axios
      .get(`https://api.personatalenta.id/product/list`, {
        headers: {
          Authorization: `Bearer ${token ? token : ""}`,
          "Content-Type": "x-www-from-urlencode",
          "Access-Control-Allow-Origin": "http://localhost:3000",
          "Access-Control-Allow-Credentials": "true",
          "Access-Control-Allow-Headers":
            "Origin, X-Requested-With, Content-Type, Accept",
        },
      })
      .then((res) => {
        const data = res.data.products.filter(
          (product) => product.code === "persona_general"
        );
        data.map((product) => {
          if (product.duration == 5) {
            tmpPricing[0].product[0].id = product.id;
            tmpPricing[0].product[0].discountPrice = product.price;
            tmpPricing[0].product[0].price = product.old_price;
            tmpPricing[0].product[0].duration = product.duration;
            tmpPricing[0].product[0].duration_type = product.duration_type;
          } else if (product.duration == 10) {
            tmpPricing[0].product[1].id = product.id;
            tmpPricing[0].product[1].discountPrice = product.price;
            tmpPricing[0].product[1].price = product.old_price;
            tmpPricing[0].product[1].duration = product.duration;
            tmpPricing[0].product[1].duration_type = product.duration_type;
          }
        });
        setPricingPlans(tmpPricing);
      })
      .catch((err) => {
        if (
          err.response.data.message === "Unauthorized" ||
          err.response.data === "Unauthorized"
        ) {
          // navigate('/');
        }
      });
  }, []);
  console.log(props);
  const handleBuy = (plan) => {
    if (
      props?.data?.type === "colleague" ||
      props?.data?.type === "friend" ||
      props?.type === "colleague" ||
      props?.type === "friend"
    ) {
      window.location.assign(
        `/dashboard/friend-list/${props?.data?.type ?? props?.type}/${
          props?.data?.id ?? props?.user?.id
        }/checkout/${plan?.id}`
      );
    } else if (props?.user) {
      window.location.assign(
        `/dashboard/profile/${props?.user?.username}/checkout/${plan?.id}`
      );
    } else {
      window.location.assign("/login?service=matching");
    }
  };

  return (
    <Grid
      container
      spacing={3}
      sx={{
        width: "100%",
        flexWrap: "wrap",
        overflow: "auto",
        WebkitOverflowScrolling: "touch",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": { display: "none" },
      }}
    >
      {pricingPlans.map((plan, index) => {
        const isPurchase = props.product?.find(
          (element) => element.isPurchase === true
        );
        return (
          <Grid
            item
            xs={12}
            sm={6}
            md={3}
            width={300}
            key={index}
            className={classes.gridPrice}
          >
            <Card className={classes.pricingCard}>
              <Typography
                variant="h6"
                component="div"
                gutterBottom
                className={classes.pricingCardTitle}
              >
                {plan.name}
              </Typography>
              <Flex
                flexDirection="row"
                width="100%"
                flex={1}
                gap={6}
                justifyContent="center"
                pb={5}
              >
                {plan.product.map((item, index) => (
                  <Flex
                    key={index}
                    className={classes.containerPricing}
                    gap={2}
                  >
                    <Typography
                      variant="h6"
                      className={classes.pricingDuration}
                    >
                      {item.duration} {item.duration_type}
                    </Typography>
                    <Typography
                      variant="h6"
                      component="del"
                      className={classes.pricingCardPrice}
                    >
                      Rp {formatPrice(item.price)}
                    </Typography>
                    <Typography
                      variant="h6"
                      component="ins"
                      className={classes.pricingCardPrice}
                    >
                      Rp {formatPrice(item.discountPrice)}
                    </Typography>
                    {isPurchase ? (
                      <div className={classes.btnPurchased}>
                        <span>Sudah Beli</span>
                      </div>
                    ) : (
                      <div
                        className={classes.btnBuy}
                        onClick={() => handleBuy(item)}
                      >
                        <span>Beli</span>
                      </div>
                    )}
                  </Flex>
                ))}
              </Flex>
              <Typography
                variant="caption"
                component="div"
                className={classes.pricingCardDesc}
              >
                {plan.desc}
              </Typography>
              {expand !== index && (
                <Text
                  cursor="pointer"
                  onClick={() => setExpand(index)}
                  py={2}
                  px={5}
                  textAlign="end"
                  fontSize="sm"
                >
                  Detail
                </Text>
              )}
            </Card>
            {expand === index && (
              <Card className={classes.cardDesc}>
                <Typography
                  variant="h6"
                  component="div"
                  className={classes.titleService}
                >
                  Service {plan.name}:
                </Typography>
                <Typography
                  variant="body1"
                  component="div"
                  gutterBottom
                  className={classes.pricingCardFeatures}
                >
                  <ul>
                    {plan.features.map((feature, index) => (
                      <li key={index}>{feature}</li>
                    ))}
                  </ul>
                </Typography>
                <Text
                  cursor="pointer"
                  onClick={() => setExpand(-1)}
                  py={2}
                  px={5}
                  textAlign="end"
                  fontSize="sm"
                >
                  See less
                </Text>
              </Card>
            )}
          </Grid>
        );
      })}
    </Grid>
  );
};

export default PricingPersona;
